import { render, staticRenderFns } from "./administratorForm.vue?vue&type=template&id=edbc6426&scoped=true&"
import script from "./administratorForm.vue?vue&type=script&lang=js&"
export * from "./administratorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbc6426",
  null
  
)

export default component.exports